<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="decline()">
    <img src="assets/img/icon_cancel.png" alt="close icon" />
  </button>
</div>

<div class="modal-body">
  <div class="loading-overlay" *ngIf="pendingRequests > 0">
    <div class="spinner-border" role="status"></div>
  </div>
  <form [formGroup]="form">
    <div class="border-container mb-5">
      <h4 class="border-title">Address</h4>
      <div class="content">
        <div class="row mt-2 mb-3">
          <div class="col-md-4 custom-select">
            <label for="lgaId">LGA</label>
            <select id="lgaId" class="form-control" formControlName="lgaId" (change)="getAreas()">
              <option value="" disabled>Select an option</option>
              <option [value]="lga.id" *ngFor="let lga of lgas">{{ lga.name | titlecase }}</option>
            </select>
          </div>

          <div class="col-md-4 custom-select">
            <label for="areaId">Area</label>
            <select id="areaId" class="form-control" formControlName="areaId">
              <option value="">Select an option</option>
              <option [value]="area.id" *ngFor="let area of areas">{{ area.name | titlecase }}</option>
            </select>
          </div>

          <div class="col-md-4 mb-2">
            <label for="address">Residential Address</label>
            <input id="address" type="text" class="form-control custom-input" placeholder="Enter address" formControlName="address"/>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="border-container mb-5">
    <h4 class="border-title">Profiling Details</h4>
    <form [formGroup]="profilingForm" class="content">
      <div class="row mt-2 mb-3">
        <div class="col-md-6 custom-select">
          <label for="profilingType">Profiling Type</label>
          <select id="profilingType" class="form-control" formControlName="profilingType" (change)="onProfilingType()">
            <option value="">Select Profiling Type</option>
            <option [value]="pt.value" *ngFor="let pt of profilingTypes">{{ pt.label }}</option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'APLUC'" class="col-md-6 custom-select">
          <label for="aplucCategoryId">APLUC Category</label>
          <select id="aplucCategoryId" class="form-control" formControlName="aplucCategoryId" (change)="onAplucCategoryChange()">
            <option value="">Select category</option>
            <option [value]="category?.id" *ngFor="let category of aplucCategories">{{ category?.name || category?.categoryName || category?.label }}</option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'APLUC'" class="col-md-6 custom-select">
          <label for="aplucTypeId">APLUC Type</label>
          <select id="aplucTypeId" class="form-control" formControlName="aplucTypeId" (change)="onAplucTypeChange()">
            <option value="">Select type</option>
            <option [value]="type?.id" *ngFor="let type of aplucTypes">{{ type?.name || type?.typeName || type?.label }}</option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'APLUC'" class="col-md-6 custom-select">
          <label for="aplucRateId">APLUC Rate</label>
          <select id="aplucRateId" class="form-control" formControlName="aplucRateId" (change)="onAplucRateChange(); onCategoryOrTypeChange()">
            <option value="">Select rate</option>
            <option [value]="rate?.id" *ngFor="let rate of aplucRates">{{ rate?.name || rate?.rateName || rate?.label || rate?.rate || rate?.amount }}</option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'ASWAMA'" class="col-md-6 custom-select">
          <label for="buildingType">Category</label>
          <select id="buildingType" class="form-control" formControlName="buildingType" (change)="onBuildingTypeChange()">
            <option value="">Select category</option>
            <option [value]="bt.id" *ngFor="let bt of buildingTypes">
              {{ bt?.name | titlecase }}
            </option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'ANSAA'" class="col-md-6 custom-select">
          <label for="ansaaCategoryId">ANSAA Category</label>
          <select id="ansaaCategoryId" class="form-control" formControlName="ansaaCategoryId" (change)="onCategoryOrTypeChange()">
            <option value="">Select category</option>
            <option [value]="category.id" *ngFor="let category of ansaaCategories">{{ category?.name | titlecase }}</option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'LICENSE'" class="col-md-6 custom-select">
          <label for="licenseCategoryId">License Category</label>
          <select id="licenseCategoryId" class="form-control" formControlName="licenseCategoryId" (change)="onCategoryOrTypeChange()">
            <option value="">Select category</option>
            <option [value]="category.id" *ngFor="let category of licenseCategories">{{ category?.name | titlecase }}</option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('buildingType')?.value" class="col-md-6 custom-select">
          <label for="buildingTypeSub">Type</label>
          <select id="buildingTypeSub" class="form-control" formControlName="buildingTypeSub" (change)="onBuildingTypeSubChange()">
            <option value="">Select type</option>
            <option [value]="bts.id" *ngFor="let bts of buildingTypeSubs">
              {{ bts?.name | titlecase }}
            </option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'ASWAMA' && profilingForm.get('buildingType')?.value && profilingForm.get('buildingType').value == 1" class="col-md-6 custom-select">
          <label for="buildingTypeSubType">Sub Type</label>
          <select id="buildingTypeSubType" class="form-control" formControlName="buildingTypeSubType" (change)="onBuildingTypeSubTypeChange()">
            <option value="">Select type</option>
            <option [value]="btst.id" *ngFor="let btst of buildingTypeSubsTypes">
              {{ btst?.name | titlecase }}
            </option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'PRESUMPTIVE_TAX'" class="col-md-6 custom-select">
          <label for="presumptiveIncomeType">Sub Type</label>
          <select
            id="presumptiveIncomeType"
            class="form-control"
            formControlName="presumptiveIncomeType"
            (change)="onCategoryOrTypeChange()"
          >
            <option value="">Select Sub type</option>
            <option [value]="incomeType.id" *ngFor="let incomeType of incomeTypes">
              {{ incomeType?.name | titlecase }}
            </option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'FIRE_SERVICE'" class="col-md-6 custom-select">
          <label for="fireServiceType">Sub Type</label>
          <select id="fireServiceType" class="form-control" formControlName="fireServiceType" (change)="onCategoryOrTypeChange()">
            <option value="">Select type</option>
            <option [value]="fireType.id" *ngFor="let fireType of fireServiceTypes">
              {{ fireType?.name | titlecase }}
            </option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'BUSINESS_PREMISES'" class="col-md-6 custom-select">
          <label for="businessPremisesTypes">Sub Type</label>
          <select id="businessPremisesTypes" class="form-control" formControlName="businessPremisesTypes" (change)="onCategoryOrTypeChange()">
            <option value="">Select type</option>
            <option
              [value]="bpit?.id"
              *ngFor="let bpit of businessPremisesIncomeTypes"
            >
              {{ bpit?.name | titlecase }}
            </option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'PRESUMPTIVE_TAX'" class="col-md-6 custom-select">
          <label for="category">Category</label>
          <select id="category" class="form-control" formControlName="category" (change)="onCategoryOrTypeChange()">
            <option value="">Select Category</option>
            <option [value]="bc.value" *ngFor="let bc of businessCategories">{{ bc.label }}</option>
          </select>
        </div>

        <div
          *ngIf="profilingForm.get('profilingType')?.value === 'HEALTH'"
          class="col-md-6 custom-select"
        >
          <label for="healthCategoryId">Health Category</label>
          <select
            id="healthCategoryId"
            class="form-control"
            formControlName="healthCategoryId"
            (change)="onHealthCategoryChange()"
          >
            <option value="">Select category</option>
            <option [value]="hc.id" *ngFor="let hc of healthCategories">
              {{ hc?.name | titlecase }}
            </option>
          </select>
        </div>

        <div
          *ngIf="profilingForm.get('profilingType')?.value === 'HEALTH' && profilingForm.get('healthCategoryId')?.value"
          class="col-md-6 custom-select"
        >
          <label for="healthFacilityTypeId">Facility Type</label>
          <select
            id="healthFacilityTypeId"
            class="form-control"
            formControlName="healthFacilityTypeId"
            (change)="onHealthFacilityTypeChange()"
          >
            <option value="">Select facility type</option>
            <option [value]="hft.id" *ngFor="let hft of healthFacilityTypes">
              {{ hft?.name | titlecase }}
            </option>
          </select>
        </div>

        <div
          *ngIf="profilingForm.get('profilingType')?.value === 'HEALTH' && profilingForm.get('healthFacilityTypeId')?.value"
          class="col-md-6 custom-select"
        >
          <label for="healthCapacityId">Capacity</label>
          <select
            id="healthCapacityId"
            class="form-control"
            formControlName="healthCapacityId"
            (change)="onCategoryOrTypeChange()"
          >
            <option value="">Select capacity</option>
            <option [value]="hcap.id" *ngFor="let hcap of healthCapacities">
              {{ hcap?.name | titlecase }}
            </option>
          </select>
        </div>

        <div
          *ngIf="profilingForm.get('profilingType')?.value === 'TOURISM'"
          class="col-md-6 custom-select"
        >
          <label for="cultureCategoryId">Category</label>
          <select
            id="cultureCategoryId"
            class="form-control"
            formControlName="cultureCategoryId"
            (change)="onCategoryOrTypeChange()"
          >
            <option value="">Select category</option>
            <option [value]="cc.id" *ngFor="let cc of cultureCategories">
              {{ cc?.name | titlecase }}
            </option>
          </select>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'EDUCATION'" class="col-md-6 custom-select">
          <label for="educationCategoryId">Category</label>
          <select
            id="educationCategoryId"
            class="form-control"
            formControlName="educationCategoryId"
            (change)="onCategoryOrTypeChange()"
          >
            <option value="">Select category</option>
            <option [value]="ec.id" *ngFor="let ec of educationCategories">
              {{ ec?.name | titlecase }}
            </option>
          </select>
        </div>

        <div class="col-md-6 mb-2">
          <label for="amount">Amount(&#x20A6;)</label>
          <input id="amount" type="text" class="form-control custom-input" [value]="amount || 0 | nairaCurrency" readonly/>
        </div>

        <div *ngIf="profilingForm.get('profilingType')?.value === 'BUSINESS_PREMISES' || profilingForm.get('profilingType')?.value === 'FIRE_SERVICE'" class="col-md-6 mb-2">
          <label for="renewalAmount">Renewal Amount(&#x20A6;)</label>
          <input
            id="renewalAmount"
            type="text"
            class="form-control custom-input"
            [value]="renewalAmount || 0 | nairaCurrency"
            readonly
          />
        </div>
      </div>
    </form>

    <button
      type="button"
      class="btn btn-block btn-dark"
      [disabled]="!profilingForm.valid || !form.valid"
      (click)="save()"
    >
      Add Profile
    </button>
  </div>

  <div class="mt-4">
    <div class="table-responsive">
      <table class="custom-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Category</th>
            <th>Sub Type</th>
            <th>Amount</th>
            <th>Renewal Amount</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody *ngIf="!isSaving && profiles?.length > 0">
          <tr *ngFor="let eachProfile of profiles">
            <td>{{ eachProfile?.assessmentType | removeUnderscores }}</td>
            <td>{{ eachProfile?.category | titlecase }}</td>
            <td>{{ eachProfile?.incomeType || '--' | titlecase }}</td>
            <td>{{ eachProfile?.amount | nairaCurrency }}</td>
            <td>
              <ng-container *ngIf="eachProfile?.renewalAmount; else noRenewal">
                {{ eachProfile?.renewalAmount | nairaCurrency }}
              </ng-container>
              <ng-template #noRenewal>n/a</ng-template>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-danger"
                (click)="remove(eachProfile?.id)"
              >
                Remove
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
